module.exports = __webpack_public_path__ + "assets/icon_annual_agreement_highlight.e0b9f972.svg";